import { toNumber } from "../../../../helpers";
import ibsStore from "../../../Stores/IbsSurveyStore"
import { sumOfConstituentsNAV, getCustomGroupingConstituents } from "../../../../ibsHelper";
import {NumberFormat } from "../../../../Enums/constants";
import { saveValueNew } from "../../../../control";
import { isNumField } from "../../../../Helpers/TableHelper";
import { formatNumber } from "../../../../Helpers/General/FormatHelper";

export function handleHOTChangeCustomAsset(table, rowNum, qId, oldValue, newValue, props, referenceToTable) {
    if (rowNum !== undefined && rowNum !== null
        && qId !== undefined && qId !== null
        && newValue != oldValue
        && newValue !== 'undefined') { // TODO something weird happens when this is changed to newValue !== oldValue

        let normalizedNewValue = newValue;

        if (isNumField(table, qId, props)) {
            normalizedNewValue = toNumber(newValue);
            if (Number.isNaN(normalizedNewValue)) {
                // It's a number field, but newValue is not a number
                // just save an empty value
                normalizedNewValue = null;
            }
        }
        //CUSTOM ASSETS, ignore these
        if (qId == "MandateStyleName" && newValue == "N/A" || qId == "Constituents") {
            return
        }

        let rowId, result;
        rowId = referenceToTable[rowNum].CustomAssetID;
        result = ibsStore.allTableResponses[props.tableName].findIndex(row => row.CustomAssetID === rowId); //where it is saved on frontend	


        ibsStore.allTableResponses[props.tableName][result][qId] = normalizedNewValue;

        let rulesSet = saveValueNew(qId, normalizedNewValue, { tableName: props.tableName, rowId })

    }
}
export function renderCustomGroupingTotalRow(props) {
    let totalRow = {};
    totalRow['CustomAssetName'] = "Total";
    let sumNAVTotal = 0
    let customGroupingsTable = ibsStore.allTableResponses['CustomGroupings']
    customGroupingsTable.forEach(grouping => {
        sumNAVTotal = sumNAVTotal + sumOfConstituentsNAV(grouping.CustomAssetID);
    })
    totalRow['NAV'] = formatNumber(NumberFormat.MONEYMILLION, sumNAVTotal);
    totalRow['ReturnPct'] = "";
    totalRow['ReturnBmPct'] = "";
    totalRow['__children'] = null;
    return totalRow
}

export function CustomGroupingCells(cellProps, row, col, prop, props, referenceToTable, listOfHeaderRows) {
    var cellProperties = cellProps;
    if (prop == "Constituents" && row < referenceToTable.length) {
        let customAssetID = referenceToTable[row].CustomAssetID
        cellProperties.source = getCustomGroupingConstituents(customAssetID)
    } else if (prop == "NAV" && row < referenceToTable.length) {
        let customAssetID = referenceToTable[row]?.CustomAssetID
        let sumNAV = sumOfConstituentsNAV(customAssetID);
        cellProperties.renderer = (instance, td, row, col, prop, value, cellProperties) => {
            td.innerHTML = formatNumber(NumberFormat.MONEYMILLION, sumNAV)
            cellProperties.readOnly = true;
            td.className = "readOnlyCell htRight";
        };
    } 

    return cellProperties;
}